import GenericButton from "./GenericButton";

export default GenericButton;
